import React, { useCallback, useContext, useState } from 'react'
import { Alert } from 'components'
import { AutoComplete, Button } from 'components/Form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { CreateBatteryStyles } from './Style'
import { duplicateForLearningGroupFetch, duplicateForSchoolClassFetch } from 'store/middlewares/assessment.crud'
import { AssessmentsContext } from './AssessmentsContext'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { getLearningGroupsFetch } from 'store/middlewares/testTakers.crud'
import { keys, map, pickBy } from 'lodash'

const DuplicateAndAssignAlert = (props) => {
    const { handleAlert = () => { } } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments, assessmentOptions } = useContext(AssessmentsContext)
    const queryClient = useQueryClient()

    const [learningGroup, setLearningGroup] = useState(null)
    const [isSchoolClass, setIsSchoolClass] = useState(false)

    const learningGroups = useQuery({
        queryFn: [qc.learningGroups],
        queryFn: async () => {
            const { data } = await getLearningGroupsFetch()
            return data
        }
    })

    const successQuery = useCallback(() => {
        handleAlert(false)
        setResetRowSelection(true)
        setSelectedAssessments(null)
        toast(" השכפול בוצע בהצלחה", toastConfig)
    }, [])

    const { mutateAsync: duplicateForSchoolClass, isPending: duplicateSchoolClassIsPending } = useMutation({
        mutationFn: duplicateForSchoolClassFetch,
        onSuccess: () => {
            successQuery()
        }
    })

    const { mutateAsync: duplicateForLearningGroup, isPending: duplicateGroupIsPending } = useMutation({
        mutationFn: duplicateForLearningGroupFetch,
        onSuccess: () => {
            successQuery()
        }
    })

    const handleAssign = useCallback(() => {
        if (isSchoolClass)
            duplicateForSchoolClass({ learning_group: learningGroup?.id, student_battery_ids: selectedAssessments })

        else {
            if (!learningGroup) {
                toast.error('בחר קבוצת למידה', toastConfig)
                return
            }

            const assessment_ids = keys(pickBy(selectedAssessments, v => v === true));
            duplicateForLearningGroup({ learning_unit_id: learningGroup?.id, student_battery_ids: assessment_ids })
        }

    }, [learningGroup, isSchoolClass])

    const handleAssignForSchoolClass = useCallback(() => {
        const assessment_ids = keys(pickBy(selectedAssessments, v => v === true));
        duplicateForSchoolClass({ student_battery_ids: assessment_ids })
    }, [selectedAssessments])

    return (
        <Alert
            systemUI
            title={"שכפול סוללת מבדקים עבור יחידת למידה"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <div>{"חשוב לבחור יחידת למידה השייכת לתלמיד הנבחר"}</div>
                {""}
                <AutoComplete
                    name="learning_group"
                    input={{
                        value: learningGroup,
                        onChange: setLearningGroup
                    }}
                    placeholder="בחר קבוצת למידה"
                    options={learningGroups.data}
                />
                <div>
                    <Button
                        loading={duplicateGroupIsPending || duplicateSchoolClassIsPending}
                        disabled={!learningGroups || duplicateGroupIsPending || duplicateSchoolClassIsPending}
                        action={handleAssign}
                        color="thirdly"
                        label="ביצוע"
                    />
                </div>
                <div>
                    {"או"}
                </div>
                <Button
                    loading={duplicateSchoolClassIsPending || duplicateGroupIsPending}
                    disabled={duplicateSchoolClassIsPending || duplicateGroupIsPending}
                    action={handleAssignForSchoolClass}
                    color="thirdly"
                    label="שכפול עבור כיתת האם"
                />
            </CreateBatteryStyles>
        </Alert>
    )
}

export default DuplicateAndAssignAlert